// src/pages/MsCheckout.jsx
//
// Middle School Student Checkout page.
//
// This is a thin wrapper around <StudentCheckout /> that hard-scopes the
// view to grades 7-8. All real logic lives in StudentCheckout.jsx.
//
// Route: /tools/ms-checkout
// Tool id: 'ms_checkout' (granted automatically alongside 'student_checkout'
//   to anyone with any checkout section assignment — see syncCheckoutClaims).

import React from 'react';
import StudentCheckout from './StudentCheckout';

const MsCheckout = () => (
  <StudentCheckout
    defaultGradeFilter="ms"
    hideGradeFilter
    pageTitle="MS Student Checkout"
  />
);

export default MsCheckout;